import React, {useEffect, useReducer, useState} from 'react'
import {HashRouter as Router, Route, Routes} from 'react-router-dom'
import './app.scss'
import '@sbab-ui/components/style.css'
import '@sbab-ui/tokens/custom-properties.css';
import {Questionnaire, Result} from './layouts'
import {actions, initialState, reducer} from './state'
import {I18nProvider} from "@sbab-ui/components";

const App = () => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const [result, setResult] = useState(0)

  useEffect(() => {
    const updateResult = resultValue => {
      setResult(resultValue)
    }
    if (state.submitted) {
      updateResult(state.result)
    }
  }, [state.submitted, state.result])

  return (
      <I18nProvider locale={"sv"}>
        <div className='BufferCalculatorApp'>
          <Router>
            <Routes>
              <Route
                path='/'
                element={
                  <Questionnaire
                    state={state}
                    dispatch={dispatch}
                    actions={actions}
                  />
                }
              />
              <Route path='result' element={<Result sum={result} />} />
            </Routes>
          </Router>
        </div>
      </I18nProvider>
  )
}

export default App
